<template>
  <div>
    <span v-if="orderServiceItem.type === 'hotel'">
      {{ $t("travelService.orderServicesCustomerForm.fromDateHotel") }}
      <b>{{ orderServiceItem.travelServiceOrderItemHotel.start_date }} {{ orderServiceItem.travelServiceOrderItemHotel.start_time }}</b>
      {{ $t("travelService.orderServicesCustomerForm.toDateHotel") }}
      <b>{{ orderServiceItem.travelServiceOrderItemHotel.end_date }}</b>
    </span>
    <span v-if="orderServiceItem.type === 'flight'">
      {{ $t("travelService.orderServicesCustomerForm.fromDateFlight") }}
      <b>{{ orderServiceItem.travelServiceOrderItemFlight.start_date }} {{ orderServiceItem.travelServiceOrderItemFlight.start_time }}</b>
      <span v-if="orderServiceItem.travelServiceOrderItemFlight.return_date != null">
        {{ $t("travelService.orderServicesCustomerForm.returnDateFlight") }}
        <b>{{ orderServiceItem.travelServiceOrderItemFlight.return_date }} {{ orderServiceItem.travelServiceOrderItemFlight.return_time }}</b></span
      >
    </span>
    <span v-if="orderServiceItem.type === 'rail'">
      {{ $t("travelService.orderServicesCustomerForm.fromDateRail") }}
      <b>{{ orderServiceItem.travelServiceOrderItemRail.start_date }} {{ orderServiceItem.travelServiceOrderItemRail.start_time }}</b>
      <span v-if="orderServiceItem.travelServiceOrderItemRail.return_date != null">
        {{ $t("travelService.orderServicesCustomerForm.returnDateRail") }}
        <b>{{ orderServiceItem.travelServiceOrderItemRail.return_date }} {{ orderServiceItem.travelServiceOrderItemRail.return_time }}</b></span
      >
    </span>
    <span v-if="orderServiceItem.type === 'car'">
      {{ $t("travelService.orderServicesCustomerForm.fromDateCar") }}
      <b>{{ orderServiceItem.travelServiceOrderItemCar.start_date }} {{ orderServiceItem.travelServiceOrderItemCar.start_time }}</b>
      {{ $t("travelService.orderServicesCustomerForm.toDateCar") }}
      <b>{{ orderServiceItem.travelServiceOrderItemCar.end_date }} {{ orderServiceItem.travelServiceOrderItemCar.end_time }}</b>
    </span>
    <span v-if="orderServiceItem.type === 'insurance'">
      {{ $t("global.startDate") }}
      <b>{{ orderServiceItem.travelServiceOrderItemInsurance.start_date }}</b> <br />
      {{ $t("global.endDate") }}
      <b>{{ orderServiceItem.travelServiceOrderItemInsurance.end_date }}</b>
    </span>
  </div>
</template>

<script>
export default {
  name: "OrderServicesRequestDates",
  props: { orderServiceItem: { required: true } }
};
</script>

<style scoped></style>
